define('models/Podio.Models.File',['require','underscore','lib/backbone/Backbone.PodioModel','lib/Podio.Routes','lib/Podio.Transport','models/Podio.Models.User','collections/Podio.Collections.Files','collections/Podio.Collections.Comments'],function(require) {

  var _ = require('underscore');
  var PodioModel = require('lib/backbone/Backbone.PodioModel');
  var routes = require('lib/Podio.Routes');
  var transport = require('lib/Podio.Transport');

  return PodioModel.extend({

    idAttribute: 'file_id',

    urlRoot: function() {
      return routes.files_path({ format: '' });
    },

    has_one: function() {
      return {
        'created_by': require('models/Podio.Models.User')
      };
    },

    has_many: function() {
      return {
        'replaces': require('collections/Podio.Collections.Files'),
        'comments': require('collections/Podio.Collections.Comments')
      };
    },

    initialize: function() {
      this._super();
      _.bindAll(this, 'attachToReference');
    },

    hasComments: function() {
      return this.get('comment_count') > 0;
    },

    attachToReference: function(refType, refId, callback) {
      var url = routes.attach_file_path(this.get('id') || this.get('file_id'), refType, refId);
      transport.postJSON(url, {}, callback); // Replace with this.request method, but requires re-write since it don't accept a callback.
    },

    replaceWith: function(newFile, callback) {
      var url = routes.replace_file_path(this.get('id') || this.get('file_id')); // Replace with this.request method, but requires re-write since it don't accept a callback.
      transport.postJSON(url, { requestData: { new_file_id: newFile.get('id') || newFile.get('file_id') } }, callback);
    },

    subscribe: function() {
      this.set( {'subscribed' : true });
      return this.request('post', routes.subscribe_path('file', this.get('file_id')), {});
    },

    unsubscribe: function() {
      this.set( {'subscribed' : false });
      return this.request('delete', routes.unsubscribe_path('file', this.get('file_id')), {});
    },

    like: function(variant) {
      return this.request('post', routes.rating_path('file', this.get('file_id') , 'like', { value: 1, variant: variant } ));
    },

    unlike: function(variant) {
      return this.request('delete', routes.rating_path('file', this.get('file_id') , 'like', { value: 1, variant: variant } ));
    }
  });

});

